import { Pipe, PipeTransform } from '@angular/core';

/** CSS class for the mission badge of a catalog card. */
@Pipe({ name: 'satelliteTypeClass', standalone: true })
export class SatelliteTypeClassPipe implements PipeTransform {
  transform(mission: string): string {
    if (!mission) return 'unknown';

    const missionLower = mission.toLowerCase();
    if (missionLower.includes('sentinel')) return 'sentinel';
    if (missionLower.includes('landsat')) return 'landsat';
    return 'unknown';
  }
}

/** Short mission label for the badge of a catalog card. */
@Pipe({ name: 'satelliteTypeShort', standalone: true })
export class SatelliteTypeShortPipe implements PipeTransform {
  transform(mission: string): string {
    if (!mission) return '?';

    const missionLower = mission.toLowerCase();
    if (missionLower.includes('sentinel')) return 'S2';
    if (missionLower.includes('landsat')) return 'L8';
    return '?';
  }
}

/** Display name of a satellite task type. */
@Pipe({ name: 'satelliteName', standalone: true })
export class SatelliteNamePipe implements PipeTransform {
  transform(satelliteType: number): string {
    switch (satelliteType) {
      case 0:
        return 'Sentinel-2';
      case 1:
        return 'Landsat-8';
      case 2:
        return 'Landsat-9';
      default:
        return 'Unknown';
    }
  }
}

/** Maps a satellite task status code to its badge CSS class. */
@Pipe({ name: 'taskStatusClass', standalone: true })
export class TaskStatusClassPipe implements PipeTransform {
  transform(status: number): string {
    if (status <= 2) return 'status-pending'; // New, MetadataLoaded
    if (status <= 15) return 'status-processing'; // MediaLoaded .. Report Season
    if (status <= 23) return 'status-completed'; // Report Shared
    return 'status-unknown';
  }
}

/** Formats an ISO date string as `DD.MM.YYYY[ HH:mm]` without any time zone conversion. */
@Pipe({ name: 'taskDateTime', standalone: true })
export class TaskDateTimePipe implements PipeTransform {
  transform(dateString: string): string {
    if (!dateString) return '—';
    try {
      if (typeof dateString === 'string') {
        const [datePart, rawTimePart] = dateString.split('T');
        const timePart = rawTimePart ? rawTimePart.split('.')[0] : null;

        const [year, month, day] = datePart.split('-');
        if (year && month && day) {
          let formatted = `${day}.${month}.${year}`;

          if (timePart) {
            const [hours, minutes] = timePart.split(':');
            if (hours && minutes) {
              formatted += ` ${hours}:${minutes}`;
            }
          }

          return formatted;
        }
      }
      // Not an ISO date: fall back to the browser parser.
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '—';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    } catch {
      return '—';
    }
  }
}
